import React from 'react';
import MediaFrame from '../components/MediaFrame';
import { backgroundOverlay, backgroundStyle, backgroundValue, clamp, cleanHtml, gradientStyle } from '../utils/presentation';
import { imageUrl } from '../utils/setModel';

export default function IntroductionClassModule({ module }) {
  const data = module.data || {};
  const portrait = imageUrl(data.image);
  const heroMinHeight = clamp(data.minHeight, 55, 100, 78);
  const portraitSize = clamp(data.portraitSize, 50, 100, 80);
  const style = {
    ...backgroundStyle(backgroundValue(data), { size: data.backgroundSize || 'cover', position: data.backgroundPosition || 'center top', tileSize: data.backgroundTileSize }),
    backgroundColor: data.backgroundColor || '#11151c',
    '--class-accent': data.color || '#f4c85a',
    '--hero-overlay': backgroundOverlay(data, 42),
    '--hero-min-height': `${heroMinHeight}vh`,
    '--class-portrait-size': `${portraitSize}%`,
    '--class-portrait-height': `${heroMinHeight * portraitSize / 100}vh`,
  };
  return (
    <section className={`set-presentation-section set-class-hero set-portrait-${data.portraitPosition || 'right'}`} style={style}>
      <div className="set-presentation-shade" /><div className="set-presentation-gradient" style={gradientStyle(data, { direction: data.portraitPosition === 'left' ? 'to left' : 'to right', strength: 88 })} />
      <div className="container set-class-hero-content">
        {portrait && <div className="set-class-portrait"><MediaFrame type={data.mediaFrame}><img src={portrait} alt={data.title || 'Class character'} /></MediaFrame></div>}
        <div className="set-class-copy">
          {data.eyebrow && <span className="set-presentation-eyebrow">{data.eyebrow}</span>}
          {data.title && <h1>{data.title}</h1>}
          {data.catchphrase && <h2>{data.catchphrase}</h2>}
          {data.description && <div className="set-presentation-copy" dangerouslySetInnerHTML={{ __html: cleanHtml(data.description) }} />}
        </div>
      </div>
    </section>
  );
}
